module.exports = __webpack_public_path__ + "img/Physician - Drak Gray.a501b64c.png";